import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-secondary-700">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于在线观看与追剧的疑问
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              这里汇总了浏览与观看过程中最常被问到的问题，覆盖网页版入口、手机在线看、
              播放卡顿以及免费看剧说法等方向，点击问题即可展开查看。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-information-line text-primary-600"></i>
                版权提示
              </p>
              <p className="mt-2 text-sm leading-6 text-foreground-700">
                本站仅整理与韩剧在线观看相关的信息与观剧线索，不存放影视资源。观看时请选择具备正规授权的渠道，
                并尊重相关版权。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="flex items-start gap-3">
                        <span className="font-heading text-sm font-bold text-primary-600">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        <span className="text-sm font-medium text-foreground-950">{item.q}</span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-600 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-14">
                        <p className="text-sm leading-7 text-foreground-700">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}